import { type DataLayerCallbackProps } from '@dhl/datalayer'
import { type DataLayerData, type DataLayerEventConversion, type DataLayerMeta } from '../types/types.js'
import { type AdobeConversionInteractionEvent } from './types.js'
import { getDefaultMetaAttributes } from './getDefaultMetaAttributes.js'

export const writeConversionEvent = (dataLayerEvent: DataLayerCallbackProps<DataLayerData, DataLayerMeta>): void => {
  const { conversion, content, purchase, products } = dataLayerEvent.meta as DataLayerEventConversion

  const data: AdobeConversionInteractionEvent = {
    event: 'dhl_utf_conversionInteraction',
    conversion,
    content: {
      ...content,
      purchase: {
        ...purchase,
        products,
      },
      attributes: {
        ...getDefaultMetaAttributes(dataLayerEvent.data),
        ...content?.attributes,
      },
    },
  }
  window.dataLayer?.push(data)
}
